/* tslint:disable */
import { Study } from './study';

/**
 */
export class ViewOpenStudy {
    mine?: Study[];
    others?: Study[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-open-study.ts